module.exports = __webpack_public_path__ + "static/media/goals-and-targets-roe.79000bff.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/goals-and-targets-roe.mp4
// module id = 563
// module chunks = 0